export const aiTools = [
  {
    id: "appointment-note",
    path: "/tools/appointment-note",
    title: "Appointment note organizer",
    shortTitle: "Prepare my note",
    description: "Turn your own observations and questions into a shorter note to review before a consultation.",
    action: "Organize a note",
    tone: "sage",
  },
  {
    id: "support-message",
    path: "/tools/support-message",
    title: "Support message drafter",
    shortTitle: "Find caring words",
    description: "Draft a respectful check-in for a friend, partner, relative, or colleague without pushing them to talk.",
    action: "Draft a message",
    tone: "plum",
  },
  {
    id: "reflection-guide",
    path: "/tools/reflection-guide",
    title: "Guided reflection",
    shortTitle: "Untangle one thought",
    description: "Separate a situation, thought, feeling, and small next step with neutral prompts.",
    action: "Start reflecting",
    tone: "peach",
  },
];

export const browserTools = [
  { id: "breathe", path: "/tools/breathe", title: "One-minute breathing", description: "Follow a comfortable 4–4–6 rhythm.", action: "Begin breathing" },
  { id: "ground", path: "/tools/ground", title: "5–4–3–2–1 grounding", description: "Move attention through the five senses.", action: "Start grounding" },
  { id: "reflect", path: "/tools/reflect", title: "Private mood note", description: "Save a short note on this device.", action: "Write a mood note" },
  { id: "prepare", path: "/tools/prepare", title: "Visit preparation", description: "Build a note without sending any data.", action: "Prepare a visit" },
  { id: "support", path: "/tools/support", title: "Support words", description: "Adapt a prepared check-in script.", action: "Choose words" },
  { id: "sort", path: "/tools/sort", title: "Thought sorter", description: "Name one concern and one next step.", action: "Sort a thought" },
];

export function browserToolHref(id) {
  return `/tools/${encodeURIComponent(id)}`;
}
